import { 
    Mesh, 
    Texture, 
    MeshBasicMaterial, 
    DoubleSide, 
    PlaneGeometry, 
    CubeUVReflectionMapping, 
    RepeatWrapping
} from 'three'


/**
 * Provide Label with text Mesh
 * @param {string} message 
 * @param {string} name 
 * @returns object
 */
 export const getError = ( message, title ) => new Promise( resolve => {

    let createCanvas = message => new Promise( (resolve) => {
        var bitmap = document.createElement('canvas')
        var g = bitmap.getContext('2d')
        bitmap.width = 900
        bitmap.height = 300
        g.font = 'Bold 60px Arial'

        let i = 100

        g.fillStyle = 'white'
        g.fillText(title, 50, i)
        g.strokeStyle = 'black'
        g.strokeText(title, 50, i)
    
        g.font = '40px Arial'

        message.split('\n').forEach(element => {
            i = i+60
            g.fillStyle = 'white'
            g.fillText(element, 50, i)
            g.strokeStyle = 'black'
            g.strokeText(element, 50, i)
        });

        resolve( bitmap )
    } )

    let createTexture = message => createCanvas( message ).then( canvas => 
        new Promise ( resolve => {
            let texture = new Texture( canvas )
            texture.wrapS = RepeatWrapping
            texture.wrapT = RepeatWrapping
            texture.mapping = CubeUVReflectionMapping
            texture.needsUpdate = true
            resolve( texture )
        })
    )

    let createMesh = message => createTexture( message ).then( texture => 
        new Promise ( resolve => {
            let material = new MeshBasicMaterial( { map: texture, side: DoubleSide } )
            let geometry = new PlaneGeometry( 0.3, 0.1 )
        
            resolve( {geometry, material} )
        })
    )

    let setupMesh = message => createMesh( message ).then( ({geometry, material}) => 
        new Promise ( resolve => {
            let mesh = new Mesh( geometry, material )
            mesh.scale.set( 10, 10, 10 )
            resolve( mesh )
        })
    )

    resolve( setupMesh( message ) )
})